import { render, staticRenderFns } from "./SelfPayDialog.vue?vue&type=template&id=15f601be&"
import script from "./SelfPayDialog.vue?vue&type=script&lang=js&"
export * from "./SelfPayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports